import type { RouteRecordRaw, Router } from 'vue-router'

const PublicComplaintRoutes: RouteRecordRaw = {
  path: '/claim/publicComplaint',
  name: 'PublicComplaintModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'PublicComplaintMainRoute',
      component: () => import('./views/PublicComplaintView.vue'),
      meta: {
        title: 'publicComplaint.publicComplaintClaims',
      },
    },
    {
      path: 'create',
      name: 'PublicComplaintCreateRoute',
      component: () => import('./views/PublicComplaintUpsertView.vue'),
      meta: {
        title: 'publicComplaint.createPublicComplaint',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:publicComplaintId',
      name: 'PublicComplaintEditRoute',
      component: () => import('./views/PublicComplaintUpsertView.vue'),
      meta: {
        title: 'publicComplaint.editPublicComplaint',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:publicComplaintId',
      name: 'ViewPublicComplaintRoute',
      component: () => import('./views/SinglePublicComplaintView.vue'),
      meta: {
        title: 'publicComplaint.ViewPublicComplaint',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(PublicComplaintRoutes)
}
